import localStorageUtil from '@/common/utils/localStorageUtil';
import Utils from '@/common/utils/utils';
import { Tooltip } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react'
import './OverFlowTooltip.css'

export default function OverFlowTooltipWithCustomCss(props) {
   // Create Ref
   const textElementRef = useRef();
   let projectInUseId = localStorageUtil.getSelectedProjectId()
   const compareSize = () => {
       const compare = textElementRef.current.scrollWidth > textElementRef.current.clientWidth;
       setHover(compare);
   };
   let style = { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' };
   if(!Utils.isEmptyObject(props?.style)){
    style = {...style,...props?.style}
   }
   // compare once and add resize listener on "componentDidMount"
   useEffect(() => {
       compareSize();
       window.addEventListener('resize', compareSize);
   }, [projectInUseId, props]);

   // remove resize listener again on "componentWillUnmount"
   useEffect(() => {
       window.removeEventListener('resize', compareSize);
   }, [projectInUseId, props]);

   // Define state and function to update the value
   const [hoverStatus, setHover] = useState(false);
   return (
    <Tooltip
    title={props.value}
    disableHoverListener={!hoverStatus}
    placement= {props.placement || 'top-start'}
    arrow
>
    <div 
         onClick={props.onClick}
         ref={textElementRef} 
         className={`${props.className ? props.className : ''} overFlow-lineHeight`}
         style={{
             ...style
         }}>
         {props.avatar && (<span className='knowledge-item' style={{marginRight: "10px"}}><img src={props.avatar} alt="" style={{width: "24px", height: "24px", maxWidth: "24px", maxHeight: "24px", borderRadius: "50%"}} /></span>)}
        {props.value}
    </div>
</Tooltip>
   );
}

OverFlowTooltipWithCustomCss.defaultProps = {
    value: ''
}
